
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"play3","transform":"translate(-194.03 -612.401)"}},[_c('circle',{attrs:{"id":"Ellipse_345","data-name":"Ellipse 345","cx":"32","cy":"32","r":"32","transform":"translate(194.03 612.401)","fill":"red"}}),_c('g',{attrs:{"id":"Group_20856","data-name":"Group 20856","transform":"translate(220.615 630.704)"}},[_c('path',{attrs:{"id":"Path_209256","data-name":"Path 209256","d":"M219,634.838c0-3.274.221-5.376,2.572-5.428a6.093,6.093,0,0,1,3.367,1.336c3,1.971,4.7,3.048,10.152,9.03.665.7,1.672,1.924,1.674,2.885,0,2.1-1.388,3.385-4.594,6.092-5.13,4.382-7.339,7.873-10.046,8.051a3.682,3.682,0,0,1-3.36-3.728Z","transform":"translate(-218.761 -629.409)","fill":"#fff"}})])])])
          )
        }
      }
    